import { defineMessages } from '@alltrails/shared/react-intl';

const messages = defineMessages({
  ALL: { defaultMessage: 'All' },
  PLACES: { defaultMessage: 'Places' },
  PARKS: { defaultMessage: 'Parks' },
  TRAILS: { defaultMessage: 'Trails' },
  MAPS: { defaultMessage: 'Maps' },
  RECORDINGS: { defaultMessage: 'Activities' },
  LISTS: { defaultMessage: 'Lists' }
});

const createReactClass = require('create-react-class');

const SearchFilterMenu = createReactClass({
  handleFilterSelected(filter_value, e) {
    // this.refs.filterArrow.style.left = e.target.style.left;
    this.props.filterSelected(filter_value);
  },
  render() {
    let sortedFilters = [];
    sortedFilters = this.props.filterOrder.map(
      function (key, index) {
        let selected = '';
        if (this.props.currentFilter == key) {
          selected = 'selected';
        }
        const filtersKey = this.props.filters[key];
        return (
          <li className={selected} onClick={this.handleFilterSelected.bind(null, key)} key={index}>
            {this.props.intl.formatMessage(messages[filtersKey.toUpperCase()])}
          </li>
        );
      }.bind(this)
    );
    return (
      <div className="action-bar lighter search-box clearfix">
        <menu className="title clearfix filter-menu tabs">{sortedFilters}</menu>
      </div>
    );
  }
});

export { SearchFilterMenu };
